import MD5 from 'crypto-js/md5';

export const idHash = (parts) => {
    if (!Array.isArray(parts)) {
        return MD5('').toString();
    }

    const validParts = parts
        .filter((item) => item != null && item !== '')
        .map((item) => String(item));

    return MD5(validParts.join('')).toString();
};
